// // pages/AddOrderForm.js
// import React, { useEffect } from 'react';
// import {
//   Form,
//   Input,
//   InputNumber,
//   Button,
//   DatePicker,
//   Select,
//   Typography,
//   Card,
//   Row,
//   Col,
// } from 'antd';
// import { useNavigate } from 'react-router-dom';


// const { Title } = Typography;
// const { Option } = Select;

// const AddOrderForm = () => {
//   const [form] = Form.useForm();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleEsc = (event) => {
//       if (event.key === 'Escape') {
//         navigate('/orders');
//       }
//     };
//     document.addEventListener('keydown', handleEsc);
//     return () => document.removeEventListener('keydown', handleEsc);
//   }, [navigate]);

//   const handleFinish = (values) => {
//     console.log('Order Submitted:', values);
//     form.resetFields();
//     navigate('/orders');
//   };

//   return (
//     <div style={{ padding: '40px', background: '#f7f9fc', minHeight: '90vh' }}>
//       <Card
//         style={{
//           maxWidth: 900,
//           margin: '0 auto',
//           borderRadius: '16px',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
//         }}
//         bodyStyle={{ padding: '32px 40px' }}
//       >
//         <Title level={3} style={{ marginBottom: '32px', color: '#2c3e50' }}>
//           Create New Medication Order
//         </Title>

//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleFinish}
//           colon={false}
//           requiredMark="optional"
//         >
//           <Row gutter={24}>
//             <Col span={12}>
//               <Form.Item name="id" label="Order ID" rules={[{ required: true }]}>
//                 <Input placeholder="e.g., ORD005" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item name="supplier" label="Supplier" rules={[{ required: true }]}>
//                 <Select placeholder="Select Supplier">
//                   <Option value="MediCorp">MediCorp</Option>
//                   <Option value="PharmaPlus">PharmaPlus</Option>
//                   <Option value="Global Pharma">Global Pharma</Option>
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={24}>
//             <Col span={12}>
//               <Form.Item name="items" label="Items" rules={[{ required: true }]}>
//                 <InputNumber min={1} style={{ width: '100%' }} placeholder="Enter quantity" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item name="date" label="Order Date" rules={[{ required: true }]}>
//                 <DatePicker style={{ width: '100%' }} placeholder="Select date" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={24}>
//             <Col span={12}>
//               <Form.Item name="status" label="Status" rules={[{ required: true }]}>
//                 <Select placeholder="Select Status">
//                   <Option value="Processing">Processing</Option>
//                   <Option value="Shipped">Shipped</Option>
//                   <Option value="Delivered">Delivered</Option>
//                 </Select>
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item name="total" label="Total Amount ($)" rules={[{ required: true }]}>
//                 <InputNumber
//                   min={0}
//                   step={0.01}
//                   style={{ width: '100%' }}
//                   placeholder="e.g., 189.50"
//                 />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Form.Item>
//             <Button
//               type="primary"
//               htmlType="submit"
//               size="large"
//               block
//               style={{
//                 borderRadius: '10px',
//                 background: '#1890ff',
//                 fontWeight: '500',
//               }}
//             >
//               Submit Order
//             </Button>
//           </Form.Item>
//         </Form>
//       </Card>
//     </div>
//   );
// };

// export default AddOrderForm;
































// pages/AddOrderForm.js
import React, { useEffect } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Select,
  Typography,
  Card,
  Row,
  Col,
  Space,
} from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title } = Typography;
const { Option } = Select;

const AddOrderForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const medicationData = location.state?.medicationData;

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        navigate('/orders');
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [navigate]);

  useEffect(() => {
    if (medicationData) {
      form.setFieldsValue({
        id: `ORD-${Date.now()}`, // auto-generate order ID
        supplier: 'MediCorp',
        items: 1,
        date: null,
        status: 'Processing',
        total: medicationData.price || 0,
      });
    }
  }, [form, medicationData]);

  const handleFinish = (values) => {
    console.log('Order Submitted:', values);
    form.resetFields();
    navigate('/orders');
  };

  return (
    <div style={{ padding: '40px', background: '#f7f9fc', minHeight: '90vh' }}>
      <Card
        style={{
          maxWidth: 900,
          margin: '0 auto',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        }}
        bodyStyle={{ padding: '32px 40px' }}
      >
        <Title level={3} style={{ marginBottom: '32px', color: '#2c3e50' }}>
          Create New Medication Order
        </Title>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          colon={false}
          requiredMark="optional"
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="id" label="Order ID" rules={[{ required: true }]}>
                <Input placeholder="e.g., ORD005" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="supplier" label="Supplier" rules={[{ required: true }]}>
                <Select placeholder="Select Supplier">
                  <Option value="MediCorp">MediCorp</Option>
                  <Option value="PharmaPlus">PharmaPlus</Option>
                  <Option value="Global Pharma">Global Pharma</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="items" label="Items" rules={[{ required: true }]}>
                <InputNumber min={1} style={{ width: '100%' }} placeholder="Enter quantity" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="date" label="Order Date" rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} placeholder="Select date" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true }]}>
                <Select placeholder="Select Status">
                  <Option value="Processing">Processing</Option>
                  <Option value="Shipped">Shipped</Option>
                  <Option value="Delivered">Delivered</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="total" label="Total Amount ($)" rules={[{ required: true }]}>
                <InputNumber
                  min={0}
                  step={0.01}
                  style={{ width: '100%' }}
                  placeholder="e.g., 189.50"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => navigate('/orders')}>Cancel</Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{
                  borderRadius: '10px',
                  background: '#1890ff',
                  fontWeight: '500',
                }}
              >
                Submit Order
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddOrderForm;
